<template>
  <footer class="footer">
    <div class="has-text-centered">
      <p class="footer-content">
        Streamline IT Solutions 2019
      </p>
    </div>
  </footer>
</template>

<script>
export default {

  data () {
    return this.$store.state.pkg
  }

}
</script>

<style lang="scss" scoped>
@import '~bulma/sass/utilities/_all';

.footer {
  position: absolute;
  bottom: 0px;
  width: calc(100% - 180px);
  padding: 2.5rem 0.5rem 1.5rem;
  margin-left: 180px;

  .footer-content {
    margin: 0;
    color: dimgrey;
  }

  @include mobile() {
    margin-left: 0;
  }
}
</style>
